import loadable from '@loadable/component';

export const PboSiteWrapper = loadable(
  () => import(/* webpackChunkName: "pbo-site" */ './PboSiteWrapper'),
);
